import { daikin, kuleuven, scouts } from "../assets/img/Company logo's";

const experiences = [
  {
    title: "Postgraduate Certificate: AI in Business and Industry",
    company_name: "KU Leuven, Kortrijk",
    icon: kuleuven,
    iconBg: "#FFFFFF",
    date: "2025 - 2026",
    points: [
      "Academically grounded programme covering the full AI stack: neural networks, deep learning fundamentals, computer vision, object detection, and image segmentation.",
      "Hands-on multimodal project combining visual, text, and tabular data in an end-to-end trained pipeline.",
      "Counts as 50% of the Advanced Master in AI for Business & Industry at KU Leuven.",
    ],
  },
  {
    title: "Project Lead & Software Developer",
    company_name: "Daikin Europe N.V.",
    icon: daikin,
    iconBg: "#FFFFFF",
    date: "Oct 2023 - Present",
    points: [
      "Leading software projects end-to-end: requirements gathering, technical specification writing, budget and schedule alignment with external development partners, and validation testing.",
      "Owned the full lifecycle of a logging and diagnostics tool for the newest generation of heat pumps, serving both field quality engineers and on-site installers.",
      "Contributing hands-on as a developer: building internal Python tooling, conducting field claim investigations, and bridging business requirements to supplier deliverables through rigorous specification and acceptance testing.",
    ],
  },
  {
    title: "Master Industrial Science: Electronics-ICT Connected Systems",
    company_name: "KU Leuven + University of Southern Denmark",
    icon: kuleuven,
    iconBg: "#FFFFFF",
    date: "2022 - 2023",
    points: [
      "Broad technical curriculum: computer architecture, embedded systems, photonics, signal processing, coding and algorithm courses, and control theory, with a specialisation in connected/communicating systems.",
      "Erasmus semester at the University of Southern Denmark (Odense), Europe's leading robotics hub, with coursework in guidance, navigation and control.",
      "Thesis at the Soft Robotics Research Group resulted in a published paper on human-robot interaction with a bio-inspired hexapod robot. Graduated Cum Laude.",
    ],
  },
  {
    title: "Bachelor Industrial Science: Electronics-ICT",
    company_name: "KU Leuven, Ghent",
    icon: kuleuven,
    iconBg: "#FFFFFF",
    date: "2019 - 2022",
    points: [
      "Solid engineering foundation spanning both physical and digital disciplines: kinematics, dynamics, material science, and chemistry, combined with hands-on electronics, software programming, 3D design, and rapid prototyping.",
      "Builds the physical intuition that underpins meaningful work at the hardware-software boundary.",
    ],
  },
  {
    title: "Scouting Leader",
    company_name: "Scouts Knokke",
    icon: scouts,
    iconBg: "#FFFFFF",
    date: "Sept 2018 - Aug 2022",
    points: [
      "Served as a youth leader for 4 years, taking responsibility for the development, safety, and experience of groups of children across weekly activities and multi-day camps.",
      "Progressed to Head of Materials, owning the full logistics of equipment across all group events, from inventory management to on-site coordination.",
    ],
  },
];

export { experiences };
